import React from "react";
import { Container, Typography, Button, Grid } from "@material-ui/core";
import useStyles from "./styles";
import CartItem from "../CartItem/CartItem";
import { Link } from "react-router-dom";

const Cart = ({ cart, onRemoveFromCart, onEmptyCart, onUpdateCartQty }) => {
    const classes = useStyles();

    const EmptyCart = () => (
        <>
            <Typography
                align="center"
                variant="subtitle1"
                className={classes.noCart}
            >
                No items in cart,{" "}
                <Link to="/" className={classes.link}>
                    let's add some!
                </Link>
            </Typography>
            <div className={classes.btnContainer}>
                <Button
                    className={classes.noCartButton}
                    component={Link}
                    to="/"
                    size="large"
                    type="button"
                    variant="contained"
                    color="secondary"
                >
                    Children's
                </Button>
                <Button
                    className={classes.noCartButton}
                    component={Link}
                    to="/"
                    size="large"
                    type="button"
                    variant="contained"
                    color="primary"
                >
                    Young Adult
                </Button>
                <div className={classes.grow}></div>
            </div>
        </>
    );

    const FilledCart = () => (
        <>
            <Grid container spacing={3}>
                {cart.line_items.map((item) => (
                    <Grid item xs={12} sm={4} key={item.id}>
                        <CartItem
                            item={item}
                            onUpdateCartQty={onUpdateCartQty}
                            onRemoveFromCart={onRemoveFromCart}
                        />
                    </Grid>
                ))}
            </Grid>
            <div className={classes.cardDetails}>
                <Typography variant="h4">
                    Subtotal: {cart.subtotal.formatted_with_symbol}
                </Typography>
                <div>
                    <Button
                        className={classes.emptyButton}
                        size="large"
                        type="button"
                        variant="contained"
                        color="secondary"
                        onClick={onEmptyCart}
                    >
                        Empty Cart
                    </Button>
                    <Button
                        component={Link}
                        to="/checkout"
                        className={classes.checkoutButton}
                        size="large"
                        type="button"
                        variant="contained"
                        color="primary"
                    >
                        Checkout
                    </Button>
                </div>
            </div>
        </>
    );

    if (!cart.line_items) return "Loading...";

    return (
        <Container>
            <div className={classes.toolbar} />
            <Typography
                align="center"
                className={classes.title}
                variant="h4"
                gutterBottom
            >
                Your Shopping Cart
            </Typography>
            {!cart.line_items.length ? <EmptyCart /> : <FilledCart />}
        </Container>
    );
};

export default Cart;
